import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/event-packages`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.get(`${url}/event-packages/${id}`, options).then((response) => {
    let pack = jsona.deserialize(response.data);
    delete pack.links;
    return pack;
  });
}

function add(pack) {
  const payload = jsona.serialize({
    stuff: pack,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/event-packages`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(pack) {
  const payload = jsona.serialize({
    stuff: pack,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/event-packages/${pack.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/event-packages/${id}`, options);
}

function getRegistrationsReport(id) {
  const options = {
    headers: {},
    responseType: "blob",
  };

  return axios.get(`${url}/event-packages/${id}/reports/registrations`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  getRegistrationsReport,
};
